module.exports = __webpack_public_path__ + "img/cash-fill.bc68228f.svg";